import $ from 'jquery';

export const onSavingCanvasWithAnimation = (savingWithAnimation) => {
  if (savingWithAnimation) {
    $('#editor-menu-salva #editor-btn-spinner').show();
    $('#editor-menu-salva span').text('Salvataggio in corso');
  } else {
    $('#editor-menu-salva #editor-btn-spinner').hide();
    $('#editor-menu-salva span').text('Salva');
  }
};
